import React  from "react";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/lib/integration/react';
import {store, persistor} from './store/configureStore';
import AppNavigator from "./navigations/AppNavigator";

function App() {
  return (
    <Provider store={store}>
      <PersistGate
        loading={
          <div className="flex min-h-screen items-center justify-center bg-[#2B2B2B]">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/25 border-t-white" />
          </div>
        }
        persistor={persistor}
      >
        <AppNavigator />
      </PersistGate>
    </Provider>
  );
}

export default App;
